import React from "react";
import { Router, Route, Link, Switch } from "react-router-dom";

import "./index.less";

import { inject, observer } from "mobx-react";
import { SessionStore, RouterStore, LocaleStore } from "@/stores/";
import { Modal } from "antd";
import { loadImage } from "@/utils";
import { project, assets, tempActivity } from "@/config.json";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import ActiveImage from "@/assets/mempool/common/active-modal.png";
export interface Props {
  session: SessionStore;
  locale: LocaleStore;
  router: RouterStore;
}

// export interface ActiveModalProps {
//   visible: boolean;
//   onCloseModal: Function;
//   [x: string]: any;
// }
// interface Props extends StoreProps, ActiveModalProps {}

@inject("session", "router", "locale")
@observer
class ActiveModal extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let activeStart = moment("2020/11/11 00:00:00").format();
    let activeEnd = moment("2020/11/18 23:59:59").format();
    let now = moment().format();
    let currentday = moment().format("DD");
    let timeBetween = moment(now).isBetween(activeStart, activeEnd, "seconds", "[]");
    console.log(now, currentday);
    let sameDay =
      localStorage.getItem("showActive") != null
        ? JSON.stringify(localStorage.getItem("showActive")).includes(currentday)
        : "";
    console.log(sameDay);
    if (timeBetween) {
      this.setState({
        showModal: true,
        currentday: currentday,
      });
    }
    if (!sameDay) {
      this.setState({
        visible: true,
      });
    }
    this.setState({
      modalBg: ActiveImage,
    });
  }

  state = {
    modalBg: "",
    showModal: false,
    visible: false,
    currentday: "",
  };

  // 关闭弹窗
  handleCancel = () => {
    this.setState({
      visible: false,
    });
    localStorage.setItem("showActive", `${this.state.currentday}-no`);
  };

  toPage = () => {
    this.handleCancel();
    window.open("https://m.contract.mempool.com/#/pages/active/active-1111/index");
  };

  render() {
    const { locale, session } = this.props;
    const { modalBg, showModal, visible } = this.state;
    return (
      <section className="active-modal-container">
        {tempActivity.enable2011 && showModal && project == "mempool" ? (
          <Modal
            visible={visible}
            closable={false}
            footer={null}
            onCancel={this.handleCancel}
            destroyOnClose={true}
            wrapClassName="active-modal-modal"
            width={520}
          >
            <img src={modalBg} className="link-image" onClick={this.toPage} />
            <CloseCircleOutlined className="close-icon" onClick={this.handleCancel} />
          </Modal>
        ) : null}
      </section>
    );
  }
}

export default ActiveModal as React.ComponentClass;
